import { OrganisationPostSchema } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import ASRSelect from "Components/Shared/ASRSelect";
import FormSubmit from "Components/Shared/FormSubmit";
import ProductTableSelect from "Components/Shared/ProductTableSelect";
import RatingTableSelect from "Components/Shared/RatingTableSelect";
import TimezoneSelect from "Components/Shared/TimezoneSelect";
import TTSSelect from "Components/Shared/TTSSelect";
import { FastField, Formik } from "formik";
import { useOrganisation } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import {
  Breadcrumb,
  Container,
  Divider,
  Form,
  Header,
  Menu,
  MenuItem,
} from "semantic-ui-react";

function OrganisationCreate() {
  const {
    save,
    validateName,
    ratingTables,
    productTables,
    create,
    uncreate,
  } = useOrganisation();

  return (
    <Fragment>
      <Menu>
        <MenuItem header>
          <Breadcrumb>
            <Breadcrumb.Section link onClick={() => uncreate()}>
              Organisations
            </Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section>Create Organisation</Breadcrumb.Section>
          </Breadcrumb>
        </MenuItem>
      </Menu>

      <Container textAlign="left" style={{ paddingTop: "40px" }}>
        <Header as="h3">Create New Organisation</Header>
        <Divider />
        <Formik
          validateOnChange={false}
          initialValues={create}
          validationSchema={OrganisationPostSchema}
          onSubmit={(values, actions) => {
            save(values);
          }}
        >
          {({ handleSubmit, setFieldValue, errors, validateField }) => (
            <Form onSubmit={handleSubmit}>
              <FastField
                name="name"
                label="Name"
                validate={validateName}
                component={CallableInput}
              />

              <RatingTableSelect
                name="terminationRates"
                label="Termination Rates"
                appliedAt="termination"
                ratingTables={ratingTables}
              />

              <RatingTableSelect
                name="originationRates"
                label="Origination Rates"
                appliedAt="origination"
                ratingTables={ratingTables}
              />

              <ProductTableSelect
                name="productTable"
                label="Product Table"
                productTables={productTables}
              />

              <TimezoneSelect name="timeZone" label="Time Zone" />

              <TTSSelect name="ttsLanguage" label="TTS Language" />

              <ASRSelect name="asrLanguage" label="ASR Language" />

              <FormSubmit name="Create Organisation" errors={errors} />
            </Form>
          )}
        </Formik>
      </Container>
    </Fragment>
  );
}

export default OrganisationCreate;
